var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanesha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1920,
    viewBox: "0 0 864 1536",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.05,0,0,-0.05,1642.4889,1260.6371)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -21856.109,16979.971 c 156.553,-101.661 903.728,-563.036 1665.133,-1016.59 825.45,-492.655 1416.076,-946.211 1473.003,-1133.89 128.088,-445.733 -192.128,-805.45 -611.971,-688.151 -227.712,62.56 -313.104,31.28 -249.06,-78.199 355.801,-633.413 -789.87,-805.45 -1551.275,-234.597 -291.757,218.959 -747.178,492.653 -1010.471,617.773 -925.072,422.276 -1038.928,1423.226 -149.435,1305.926 569.28,-70.379 540.817,70.378 -71.157,344.078 -348.683,164.217 -426.959,281.515 -391.377,609.953 49.812,461.372 434.071,578.675 896.61,273.697 z m -747.177,-297.159 c 28.466,-109.477 483.885,-453.557 1010.468,-774.171 526.582,-312.797 1216.826,-789.809 1544.163,-1055.689 633.318,-508.293 1110.088,-617.772 1110.088,-250.235 0,226.774 -647.55,868.009 -882.379,868.009 -71.16,0 -619.088,320.616 -1216.827,703.791 -1081.628,695.972 -1679.367,891.471 -1565.513,508.295 z m -35.578,-1376.306 c 0,-218.956 170.781,-406.634 533.695,-586.492 298.873,-148.577 747.178,-430.095 996.235,-625.594 547.928,-430.096 1245.294,-539.575 1245.294,-187.676 0,265.876 -1352.033,1305.926 -1992.469,1532.701 -654.668,234.6 -782.755,211.138 -782.755,-132.939 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanesha);
export default __webpack_public_path__ + "static/media/ganesha.3a56debf9c0e05455d0cbcaf94578d2f.svg";
export { ForwardRef as ReactComponent };